/**** cat.Branch */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'mgt',
  table: 'Agency',
  title: 'Предприятия перевозчиков',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  fields: [
    {
      name: 'agency_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      hide: true,
    },
    {
      name: 'title',
      title: 'Название',
      type: 'text',
      required: true,
    },
    {
      name: 'address',
      title: 'Адрес',
      type: 'text',
      required: false,
    },
    {
      name: 'phone',
      title: 'Телефон',
      type: 'text',
      required: false,
    },
    {
      name: 'transporter_id',
      title: 'Внешний идентификатор перевозчика',
      type: 'number',
      required: true,
      maxValue: 32767,
      minValue: 0,
    },
    {
      name: 'do_not_update',
      title: 'Отключить автообновление',
      type: 'boolean',
      required: false,
      width: '205px',
    },
  ],
  newTemplate: {
    agency_id: null,
    title: '',
    do_not_update: true,
  },
  makeIdOnInsert: true,
  updateField: 'update_date',
  defaultSort: {
    field: 'agency_id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'agency_id',
        field: 'agency_id',
      },
      {
        title: 'agency_name',
        field: 'title',
      },
      {
        title: 'agency_adress',
        field: 'address',
      },
      {
        title: 'agency_phone',
        field: 'phone',
      },
      {
        title: 'transporter_id',
        field: 'transporter_id',
      }
    ],
    example: `1;Название предприятия;Адрес предприятия;Телефон предприятия;123`,
  },
  export: {
    fields: [
      {
        name: 'title',
        title: 'Название',
      },
      {
        name: 'address',
        title: 'Адрес',
      },
      {
        name: 'phone',
        title: 'Телефон',
      },
      {
        name: 'transporter_id',
        title: 'Внешний идентификатор перевозчика',
      },
    ],
  },
};

export default config;
